import { Icon, IconProps } from '@chakra-ui/react'

export default function RemediesIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        filter="red"
        d="M13.2423 7.16547H6.75795C5.78588 7.16547 4.99805 6.37764 4.99805 5.40557V4.75697C4.99805 3.7849 5.78588 2.99707 6.75795 2.99707H13.2423C14.2144 2.99707 15.0022 3.7849 15.0022 4.75697V5.40557C15.0022 6.37764 14.2144 7.16547 13.2423 7.16547Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1953 18.0029H6.80433C5.34622 18.0029 4.16406 16.8207 4.16406 15.3626V9.80447C4.16406 8.3472 5.34622 7.16504 6.80433 7.16504H13.1962C14.6534 7.16504 15.8356 8.3472 15.8356 9.80531V15.3635C15.8356 16.8207 14.6534 18.0029 13.1953 18.0029Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99887 10.9639V14.4837"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.76 12.7235H8.24023"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99887 4.91128V5.33646"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.70786 4.91128V5.33646"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2918 4.91128V5.33646"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
